(function () {
  var root = document.querySelector('[data-byo-cart]');
  if (!root) return;
  var settings = window.byoCartSettings || {};

  function formatMoney(cents, format) {
    var value = (cents / 100).toFixed(2);
    var parts = value.split('.');
    var withCommas = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    var formatted = withCommas + '.' + parts[1];
    if (!format) return formatted;
    return format.replace(/\{\{\s*amount\s*\}\}/, formatted);
  }

  // Sync Shopify's real header cart icon badge (Horizon theme structure).
  // The count lives in .cart-bubble__text-count inside a <cart-icon> element;
  // an empty string (not "0") is required to trigger the theme's own empty-cart styling.
  function syncHeaderCartCount(cart) {
    var count = cart.item_count;
    var countText = count > 0 ? String(count) : '';
    document.querySelectorAll('.cart-bubble__text-count').forEach(function (el) {
      if (el.closest('[data-byo-cart]')) return; // don't touch our own count
      el.textContent = countText;
    });
    // Note: deliberately NOT toggling header-actions__cart-icon--has-cart here.
    // That class controls a CSS mask that cuts a hole in the cart SVG for the
    // bubble to sit in — toggling it without Shopify's own bubble system fully
    // active can leave a visible "hole" with nothing filling it.
    // Fallback attempts for other theme variants, in case selector above doesn't match
    ['[data-cart-count]', '.cart-count-bubble', '[data-header-cart-count]'].forEach(function (sel) {
      document.querySelectorAll(sel).forEach(function (el) {
        if (el.closest('[data-byo-cart]')) return;
        el.textContent = count;
      });
    });
    document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } }));
    document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { cart: cart } }));
  }

  function refreshFromCart(cart) {
    // Shipping bar
    var shipbar = root.querySelector('[data-shipbar]');
    if (shipbar && settings.threshold > 0) {
      var remaining = Math.max(0, settings.threshold - cart.total_price);
      var percent = Math.min(100, (cart.total_price / settings.threshold) * 100);
      var msg = shipbar.querySelector('[data-shipmsg]');
      var fill = shipbar.querySelector('[data-shipfill]');
      if (fill) fill.style.width = percent + '%';
      if (msg) {
        if (remaining > 0) {
          var remainingMoney = formatMoney(remaining, settings.moneyFormat);
          msg.innerHTML = shipbar.dataset.progressPrefix + '<span class="byo-cart__shipamount">' + remainingMoney + '</span>' + shipbar.dataset.progressSuffix;
        } else {
          msg.textContent = shipbar.dataset.successText;
        }
      }
    }

    // Totals
    var subtotalEl = root.querySelector('[data-subtotal]');
    var totalEl = root.querySelector('[data-total]');
    var shippingCell = root.querySelector('[data-shipping-cell]');
    var freeShipUnlocked = settings.threshold > 0 && cart.total_price >= settings.threshold;

    if (subtotalEl) subtotalEl.textContent = formatMoney(cart.original_total_price ?? cart.total_price, settings.moneyFormat);

    if (shippingCell) {
      if (freeShipUnlocked) {
        shippingCell.innerHTML = '<s class="byo-cart__ship-strike">' + formatMoney(settings.shippingCents, settings.moneyFormat) + '</s> <span class="byo-cart__ship-free">' + (settings.freeLabel || 'FREE') + '</span>';
      } else {
        shippingCell.textContent = formatMoney(settings.shippingCents, settings.moneyFormat);
      }
    }

    var displayTotal = cart.total_price + (freeShipUnlocked ? 0 : settings.shippingCents);
    if (totalEl) totalEl.textContent = formatMoney(displayTotal, settings.moneyFormat);

    var discountAmount = (cart.original_total_price ?? cart.total_price) - cart.total_price;
    var discountRow = root.querySelector('.byo-cart__row--discount');
    var discountEl = root.querySelector('[data-discount-amount]');
    if (discountAmount > 0) {
      if (discountEl) discountEl.textContent = '-' + formatMoney(discountAmount, settings.moneyFormat);
      if (discountRow) discountRow.style.display = '';
    } else if (discountRow) {
      discountRow.style.display = 'none';
    }

    // Header count (our own section heading)
    var countEl = root.querySelector('.byo-cart__count');
    if (countEl) countEl.textContent = '(' + cart.item_count + ')';

    settings.cartTotalPrice = cart.total_price;
    reindexCartLines(cart);
    syncHeaderCartCount(cart);
  }

  // Critical fix: every visible cart item's [data-cart-line] attribute must
  // match its CURRENT position in Shopify's cart, since /cart/change.js
  // identifies items by position, not by variant. Removing item #1 shifts
  // every item after it up by one position — if we don't re-sync these
  // numbers after every change, the next click can target the wrong item
  // entirely, causing stuck/incorrect totals, phantom "free shipping"
  // states, and general flakiness. Matches by variant_id, in DOM order.
  function reindexCartLines(cart) {
    var elements = Array.from(root.querySelectorAll('[data-cart-line]'));
    var usedIndexes = [];

    elements.forEach(function (el) {
      var variantId = el.dataset.variantId;
      // find the matching cart item, preferring one not already claimed
      var matchIndex = -1;
      cart.items.forEach(function (item, idx) {
        if (matchIndex === -1 && item.variant_id == variantId && usedIndexes.indexOf(idx) === -1) {
          matchIndex = idx;
        }
      });

      if (matchIndex === -1) {
        // This item is no longer in the cart at all — remove it from the DOM
        // so a stale row can never be accidentally acted on again.
        el.remove();
        return;
      }

      usedIndexes.push(matchIndex);
      var item = cart.items[matchIndex];
      el.setAttribute('data-cart-line', matchIndex + 1);

      // Keep quantity/price authoritative to Shopify's response while we're at it
      var qtyValEl = el.querySelector('[data-qty-val]');
      var priceEl = el.querySelector('.byo-cart__item-price');
      if (qtyValEl) qtyValEl.textContent = item.quantity;
      if (priceEl) priceEl.textContent = formatMoney(item.final_line_price, settings.moneyFormat);
    });
  }

  // Auto-pull real shipping rate from Settings → Shipping (domestic flat rate)
  function updateShippingAndTotalOnly() {
    var totalEl = root.querySelector('[data-total]');
    var shippingCell = root.querySelector('[data-shipping-cell]');
    var cartTotal = settings.cartTotalPrice || 0;
    var freeShipUnlocked = settings.threshold > 0 && cartTotal >= settings.threshold;

    if (shippingCell) {
      if (freeShipUnlocked) {
        shippingCell.innerHTML = '<s class="byo-cart__ship-strike">' + formatMoney(settings.shippingCents, settings.moneyFormat) + '</s> <span class="byo-cart__ship-free">' + (settings.freeLabel || 'FREE') + '</span>';
      } else {
        shippingCell.textContent = formatMoney(settings.shippingCents, settings.moneyFormat);
      }
    }
    if (totalEl) totalEl.textContent = formatMoney(cartTotal + (freeShipUnlocked ? 0 : settings.shippingCents), settings.moneyFormat);
  }

  (async function initLiveShippingRate() {
    if (!settings.useLiveShipping || !settings.shopCountry) return;
    try {
      var res = await fetch('/cart/shipping_rates.json?shipping_address[country]=' + encodeURIComponent(settings.shopCountry));
      if (!res.ok) return; // silently keep fallback value already rendered server-side
      var data = await res.json();
      if (!data.shipping_rates || data.shipping_rates.length === 0) return;
      var cheapest = data.shipping_rates.reduce(function (min, r) {
        return parseFloat(r.price) < parseFloat(min.price) ? r : min;
      });
      settings.shippingCents = Math.round(parseFloat(cheapest.price) * 100);
      updateShippingAndTotalOnly(); // no extra /cart.js round trip — reuses cart total already known from page load
    } catch (err) {
      // network/parsing issue — keep the manual fallback value already shown
    }
  })();

  async function changeLine(line, quantity) {
    const res = await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity }),
    });
    const cart = await res.json();
    return cart;
  }

  function showEmptyState() {
    var itemsEl = root.querySelector('[data-cart-items]');
    if (itemsEl) {
      itemsEl.innerHTML = '<div class="byo-cart__empty"><p>' + (root.dataset.emptyText || 'Your cart is empty.') +
        '</p><a href="' + (root.dataset.continueUrl || '/collections/all') + '" class="byo-cart__continue">' +
        (root.dataset.continueText || 'Continue shopping →') + '</a></div>';
    }
    var upsell = root.querySelector('.byo-cart__upsell');
    var discount = root.querySelector('.byo-cart__discount');
    var noteToggleEl = root.querySelector('.byo-cart__note-toggle');
    var notePanelEl = root.querySelector('.byo-cart__note-panel');
    var summary = root.querySelector('.byo-cart__summary');
    [upsell, discount, noteToggleEl, notePanelEl, summary].forEach(function (el) {
      if (el) el.style.display = 'none';
    });
  }

  // Quantity + / - and remove
  root.addEventListener('click', async function (event) {
    var itemEl = event.target.closest('[data-cart-line]');
    if (!itemEl) return;
    var line = parseInt(itemEl.dataset.cartLine, 10);
    var qtyValEl = itemEl.querySelector('[data-qty-val]');
    var currentQty = parseInt(qtyValEl.textContent, 10);

    if (event.target.closest('[data-qty-plus]')) {
      var cart = await changeLine(line, currentQty + 1);
      qtyValEl.textContent = currentQty + 1;
      var priceEl = itemEl.querySelector('.byo-cart__item-price');
      var lineItem = cart.items[line - 1];
      if (priceEl && lineItem) priceEl.textContent = formatMoney(lineItem.final_line_price, settings.moneyFormat);
      refreshFromCart(cart);
    }

    if (event.target.closest('[data-qty-minus]')) {
      var newQty = Math.max(0, currentQty - 1);
      var cart = await changeLine(line, newQty);
      if (newQty === 0) {
        itemEl.remove();
      } else {
        qtyValEl.textContent = newQty;
        var priceEl = itemEl.querySelector('.byo-cart__item-price');
        var lineItem = cart.items[line - 1];
        if (priceEl && lineItem) priceEl.textContent = formatMoney(lineItem.final_line_price, settings.moneyFormat);
      }
      refreshFromCart(cart);
      if (cart.item_count === 0) showEmptyState();
    }

    if (event.target.closest('[data-remove-item]')) {
      var cart = await changeLine(line, 0);
      itemEl.remove();
      refreshFromCart(cart);
      if (cart.item_count === 0) showEmptyState();
    }
  });

  // Discount apply / remove
  function currentCodes() {
    return Array.from(root.querySelectorAll('[data-discount-chips] [data-remove-discount]'))
      .map(function (btn) { return btn.dataset.removeDiscount; })
      .filter(Boolean);
  }

  function chipHtml(code) {
    return '<span class="byo-cart__chip">' +
      '<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M3 7v3a2 2 0 0 0 2 2h1a2 2 0 0 1 2 2v1a2 2 0 0 0 2 2h4a2 2 0 0 0 2-2v-1a2 2 0 0 1 2-2h1a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2z"/></svg>' +
      code +
      '<button type="button" data-remove-discount="' + code + '" aria-label="Remove ' + code + '">×</button>' +
      '</span>';
  }

  async function updateDiscount(codes) {
    const res = await fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ discount: codes.join(',') }),
    });
    const cart = await res.json();

    var chipsWrap = root.querySelector('[data-discount-chips]');
    if (chipsWrap) {
      var applicableCodes = (cart.discount_codes || []).filter(function (c) { return c.applicable; }).map(function (c) { return c.code; });
      chipsWrap.innerHTML = applicableCodes.map(chipHtml).join('');
    }
    refreshFromCart(cart);
  }

  root.addEventListener('submit', function (event) {
    var form = event.target.closest('[data-discount-form]');
    if (!form) return;
    event.preventDefault();
    var input = form.querySelector('[data-discount-input]');
    var code = input.value.trim();
    if (!code) return;
    updateDiscount(currentCodes().concat([code]));
    input.value = '';
  });

  root.addEventListener('click', function (event) {
    var btn = event.target.closest('[data-remove-discount]');
    if (!btn) return;
    var codeToRemove = btn.dataset.removeDiscount;
    updateDiscount(currentCodes().filter(function (c) { return c !== codeToRemove; }));
  });

  // Order note
  var noteToggle = root.querySelector('[data-note-toggle]');
  var notePanel = root.querySelector('[data-note-panel]');
  var noteChevron = root.querySelector('[data-note-chevron]');
  if (noteToggle && notePanel) {
    noteToggle.addEventListener('click', function () {
      var isHidden = notePanel.hasAttribute('hidden');
      if (isHidden) {
        notePanel.removeAttribute('hidden');
        if (noteChevron) noteChevron.style.transform = 'rotate(180deg)';
      } else {
        notePanel.setAttribute('hidden', '');
        if (noteChevron) noteChevron.style.transform = '';
      }
    });
  }
  var noteSave = root.querySelector('[data-note-save]');
  if (noteSave) {
    var originalSaveLabel = noteSave.textContent;
    noteSave.addEventListener('click', async function () {
      var noteInput = root.querySelector('[data-note-input]');
      await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ note: noteInput.value }),
      });
      noteSave.textContent = noteSave.dataset.savedLabel || 'Saved ✓';
      setTimeout(function () { noteSave.textContent = originalSaveLabel; }, 1500);
    });
  }

  // Flash upsell
  var upsellEl = root.querySelector('[data-upsell]');
  if (upsellEl) {
    (async function loadUpsell() {
      var productId = upsellEl.dataset.seedProductId;
      var limit = upsellEl.dataset.limit || 2;
      if (!productId) return;
      try {
        var res = await fetch('/recommendations/products.json?product_id=' + productId + '&limit=' + limit + '&intent=related');
        var data = await res.json();
        if (!data.products || data.products.length === 0) { upsellEl.style.display = 'none'; return; }
        var list = upsellEl.querySelector('[data-upsell-list]');
        var addLabel = list.dataset.addLabel || 'Add';
        list.innerHTML = '';
        data.products.forEach(function (product) {
          var variant = product.variants[0];
          var item = document.createElement('div');
          item.className = 'byo-upsell-item';
          var priceHtml = '<span class="byo-upsell-now">' + formatMoney(variant.price, settings.moneyFormat) + '</span>';
          if (variant.compare_at_price && variant.compare_at_price > variant.price) {
            priceHtml = '<span class="byo-upsell-old">' + formatMoney(variant.compare_at_price, settings.moneyFormat) + '</span>' + priceHtml;
          }
          var thumbSrc = product.featured_image ? product.featured_image.replace(/(\.[a-z]+)(\?.*)?$/i, '_80x80$1$2') : '';
          item.innerHTML =
            '<div class="byo-upsell-thumb">' + (thumbSrc ? '<img src="' + thumbSrc + '" alt="" width="40" height="40" loading="lazy">' : '') + '</div>' +
            '<div class="byo-upsell-info"><p class="byo-upsell-name">' + product.title + '</p><p class="byo-upsell-price">' + priceHtml + '</p></div>' +
            '<button type="button" class="byo-upsell-add" data-upsell-add="' + variant.id + '">' + addLabel + '</button>';
          list.appendChild(item);
        });
      } catch (err) {
        upsellEl.style.display = 'none';
      }
    })();
  }

  root.addEventListener('click', async function (event) {
    var btn = event.target.closest('[data-upsell-add]');
    if (!btn) return;
    var variantId = btn.dataset.upsellAdd;
    var originalLabel = btn.textContent;
    btn.disabled = true;
    try {
      var addRes = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 }),
      });
      if (!addRes.ok) throw new Error('add failed');
      var cartRes = await fetch('/cart.js');
      var cart = await cartRes.json();
      btn.textContent = 'Added ✓';
      refreshFromCart(cart);
      // Find the actual item that was added/incremented — NOT necessarily the
      // last item in the array, since if this variant was already in the cart,
      // Shopify just increases its quantity in place rather than adding a new line.
      try {
        var matchedItem = null;
        var matchedIndex = -1;
        cart.items.forEach(function (it, idx) {
          if (it.variant_id == variantId) { matchedItem = it; matchedIndex = idx; }
        });

        if (matchedItem) {
          var existingEl = root.querySelector('[data-cart-line][data-variant-id="' + matchedItem.variant_id + '"]');
          if (existingEl) {
            // Already visible in the list — just update its quantity/price in place
            var qtyValEl = existingEl.querySelector('[data-qty-val]');
            var priceEl = existingEl.querySelector('.byo-cart__item-price');
            if (qtyValEl) qtyValEl.textContent = matchedItem.quantity;
            if (priceEl) priceEl.textContent = formatMoney(matchedItem.final_line_price, settings.moneyFormat);
          } else {
            // Not visible yet — build and append a new line for it
            var itemsEl = root.querySelector('[data-cart-items]');
            if (itemsEl) {
              var rawImage = matchedItem.image;
              var imageUrl = '';
              if (typeof rawImage === 'string') {
                imageUrl = rawImage;
              } else if (rawImage && typeof rawImage === 'object') {
                imageUrl = rawImage.src || rawImage.url || '';
              } else if (matchedItem.featured_image) {
                imageUrl = (typeof matchedItem.featured_image === 'string') ? matchedItem.featured_image : (matchedItem.featured_image.url || matchedItem.featured_image.src || '');
              }
              if (imageUrl) {
                imageUrl = imageUrl.replace(/(\.[a-z]+)(\?.*)?$/i, '_160x$1$2');
              }

              var div = document.createElement('div');
              div.className = 'byo-cart__item';
              div.setAttribute('data-cart-line', matchedIndex + 1);
              div.setAttribute('data-variant-id', matchedItem.variant_id);
              div.innerHTML =
                '<div class="byo-cart__item-img">' + (imageUrl ? '<img src="' + imageUrl + '" alt="" width="56" height="56" loading="lazy">' : '') + '</div>' +
                '<div class="byo-cart__item-info">' +
                  '<a href="' + matchedItem.url + '" class="byo-cart__item-name">' + matchedItem.product_title + '</a>' +
                  (matchedItem.variant_title && matchedItem.variant_title !== 'Default Title' ? '<span class="byo-cart__item-variant">' + matchedItem.variant_title + '</span>' : '') +
                  '<div class="byo-cart__item-row">' +
                    '<div class="byo-cart__qty"><button type="button" data-qty-minus aria-label="Decrease quantity">−</button><span class="byo-cart__qty-val" data-qty-val>' + matchedItem.quantity + '</span><button type="button" data-qty-plus aria-label="Increase quantity">+</button></div>' +
                    '<span class="byo-cart__item-price">' + formatMoney(matchedItem.final_line_price, settings.moneyFormat) + '</span>' +
                  '</div>' +
                '</div>' +
                '<button type="button" class="byo-cart__remove" data-remove-item aria-label="Remove item"><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="3 6 5 6 21 6"/><path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6"/><path d="M10 11v6M14 11v6"/></svg></button>';
              itemsEl.appendChild(div);
            }
          }
        } else {
          console.error('Buyone cart: added variant not found in returned cart', variantId, cart.items);
        }
      } catch (insertErr) {
        console.error('Buyone cart: failed to insert/update upsell item in the list', insertErr);
      }
      setTimeout(function () { btn.textContent = originalLabel; }, 1500);
    } catch (err) {
      btn.textContent = originalLabel;
    } finally {
      btn.disabled = false;
    }
  });
})();